import { useState } from "react";
import type { MarcacaoFacial } from "@bookdental/schemas";
import { formatarDentes, parseTeethToFdi } from "@/components/prosthesis/fdi-teeth";
import type { ItemDoPlanoTela } from "./ItensDoPlano";

/**
 * O item que está sendo montado no editor: dentes (arcada ou texto livre), marcações da face, cor e
 * unidade do procedimento escolhido e o item em edição. O desenho da esquerda e o formulário do
 * meio leem e escrevem aqui.
 */
export function useMontagem() {
  const [fdi, setFdi] = useState<string[]>([]);
  const [manuais, setManuais] = useState("");
  const [chave, setChave] = useState(0);
  const [cor, setCor] = useState<string | null>(null);
  const [unidade, setUnidade] = useState<string | null>(null);
  const [marcacoes, setMarcacoes] = useState<MarcacaoFacial[]>([]);
  const [editando, setEditando] = useState<ItemDoPlanoTela | null>(null);
  // Muda a cada item concluído: remonta o formulário limpo.
  const [rodada, setRodada] = useState(0);

  const selecionar = (lista: string[], remontar = false) => {
    setFdi(lista);
    if (remontar) setChave((k) => k + 1);
  };
  const dentes = fdi.length ? (formatarDentes(fdi) ?? "") : manuais;
  // Texto livre que a pessoa digitou em FDI ("11, 21") também conta dentes.
  const quantidadeDeDentes = fdi.length || parseTeethToFdi(manuais).length;

  return {
    fdi,
    chave,
    cor,
    unidade,
    marcacoes,
    editando,
    rodada,
    dentes,
    quantidadeDeDentes,
    setManuais,
    setMarcacoes,
    escolherProcedimento: (p: { color: string | null; unidade?: string | null } | null) => {
      setCor(p?.color ?? null);
      setUnidade(p?.unidade ?? null);
    },
    selecionar,
    alternarArcada: (arcada: string[], marcada: boolean) =>
      selecionar(marcada ? fdi.filter((f) => !arcada.includes(f)) : Array.from(new Set([...fdi, ...arcada])), true),
    limparDentes: () => {
      selecionar([], true);
      setManuais("");
    },
    limpar: () => {
      selecionar([], true);
      setManuais("");
      setCor(null);
      setUnidade(null);
      setMarcacoes([]);
      setEditando(null);
      setRodada((r) => r + 1);
    },
    editar: (i: ItemDoPlanoTela) => {
      const lista = parseTeethToFdi(i.dentes);
      selecionar(lista, true);
      setManuais(lista.length ? "" : (i.dentes ?? ""));
      setCor(i.offeredService?.color ?? null);
      setUnidade(i.unidade);
      setMarcacoes(i.marcacoes);
      setEditando(i);
    },
  };
}
